import { AbstractControl, ValidatorFn } from '@angular/forms';

export const urlValidator: ValidatorFn = (control: AbstractControl) => {
  let validUrl = true;

  try {
    new URL(control.value);
  } catch {
    validUrl = false;
  }

  return validUrl ? null : { urlInvalid: true };
};
